// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"e095385a","453":"5ea30aab","600":"1cb33cad","861":"a5cf278c"}[chunkId] + ".chunk.js";
};